var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "details",
    {
      staticClass: "mp-used",
      attrs: { "data-testid": "monitoring_points_used_by_other_places" },
    },
    [
      _c("summary", { staticClass: "mp-used__summary" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$mpt(_vm.$t("field.used_by_other_places"))) +
            "\n    "
        ),
        _c(
          "span",
          {
            staticClass: "mp-used__count",
            attrs: { "data-testid": "used_monitoring_point_count" },
          },
          [_vm._v(_vm._s(_vm.$t("field.count", { count: _vm.rows.length })))]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mp-used__list" },
        _vm._l(_vm.rows, function (row) {
          return _c(
            "div",
            {
              key: row.id,
              staticClass: "mp-used__row",
              attrs: { "data-testid": "used_monitoring_point_row" },
            },
            [
              _c("span", { staticClass: "mp-used__type" }, [
                _vm._v(_vm._s(row.typeName)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mp-used__main min-w-0" }, [
                _c(
                  "span",
                  {
                    staticClass: "mp-used__name text-truncate min-w-0",
                    attrs: {
                      title: row.name,
                      "data-testid": "used_monitoring_point_name",
                    },
                  },
                  [_vm._v(_vm._s(row.name))]
                ),
                _vm._v(" "),
                row.place
                  ? _c(
                      "span",
                      {
                        staticClass: "mp-used__place text-truncate min-w-0",
                        attrs: {
                          title: row.place,
                          "data-testid": "used_monitoring_point_place",
                        },
                      },
                      [_vm._v(_vm._s(row.place))]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "mp-used__assigned text-truncate min-w-0",
                  attrs: {
                    title: row.assignedToPlace,
                    "data-testid": "used_monitoring_point_assigned_place",
                  },
                },
                [_vm._v(_vm._s(row.assignedToPlace))]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }